import { SWReactIcons } from "@similarweb/icons";

import { StyledCrmEnrichmentJobBanner } from "./styles";

const CrmEnrichmentJobBanner = ({ children, className }: { children: React.ReactNode; className?: string }) => {
    return (
        <StyledCrmEnrichmentJobBanner
            data-automation="crm-enrichment-job-banner"
            className={className}
        >
            <SWReactIcons
                iconName="info"
                size="sm"
            />
            {children}
        </StyledCrmEnrichmentJobBanner>
    );
};

export default CrmEnrichmentJobBanner;
